
export default function Footer() {
  return (
    <footer className="bg-[#f5f0eb] py-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-center items-center gap-6">
          {/* Copyright */}
          <div className="flex items-center gap-6 text-gray-600 text-sm">
            <span>© 2026 Hammerly. All rights reserved.</span>
          </div>

        </div>

      </div>
    </footer>
  );
}
